import { SearchFn } from "../../../../../rest/Search";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { FlagActions } from "../../../../flux/Flag/FlagActions";
import { EditServiceAccountActions } from "../EditServiceAccountActions";
import { EditServiceAccountStore } from "../EditServiceAccountStore";
import { Command } from "../../../../../Command";

export class InitUpsertServiceAccountCommand implements Command
{
    private editServiceAccountActions = new EditServiceAccountActions();
    private errorActions = new ErrorActions();
    private inProgressActions = new FlagActions();
    
    constructor(private runSearch: SearchFn, private store: EditServiceAccountStore, private getDidivionId: () => number, private errorDispatchToken: string, private inProgressDispatchToken: string)
    {        
    }
    
    execute = () => {
        this.errorActions.clearError(this.errorDispatchToken); // reset error from previous edit session
        this.inProgressActions.set(this.inProgressDispatchToken);
        this.runSearch({ Name: 'Divisions' })
            .then(res => {
                const { Division: divisions } = res.Entries
                const { DivisionId, id } = this.store.getState().draft;
                if(DivisionId == null && id == null) {
                    const currDivisionId = this.getDidivionId();
                    const division = divisions.find(d => d.id === currDivisionId);
                    if(division) {
                        this.editServiceAccountActions.setDivision(division);
                    }
                }
                this.editServiceAccountActions.setDivisionItems(divisions);
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken))
            .then(() => this.inProgressActions.reset(this.inProgressDispatchToken)); // finaly
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/ServiceAccount/commands/InitUpsertServiceAccountCommand.ts